export const ScopeSummaryMockData = [
  {
    id: '1234',
    code: '1234',
    title: 'Mock Organization',
    scopeType: 'Organization',
    hierarchy: '',
  },
] as any[];
